import { Modal } from "@xola/ui-kit";
import React from "react";
import { SecondaryButton } from "../../../Common/SecondaryButton";
import { useProduct } from "@/hooks/resources/useProduct";

interface BulkUpdateErrorModalProps {
    isOpen: boolean;
    productIds: string[];
    onClose: () => void;
}

export const BulkUpdateErrorModal = ({ isOpen, productIds, onClose }: BulkUpdateErrorModalProps) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <Modal.Header>An Error Occurred</Modal.Header>
            <Modal.Body>
                <p className="mb-4">
                    The following items could not be added. You can add them again from the Edit Collection screen.
                </p>
                <div className="max-h-64 overflow-y-auto rounded-lg border border-gray-light">
                    {productIds.map((productId, index) => (
                        <ProductErrorItem key={productId} productId={productId} index={index} />
                    ))}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <SecondaryButton onClick={onClose}>Close</SecondaryButton>
            </Modal.Footer>
        </Modal>
    );
};

interface ProductErrorItemProps {
    productId: string;
    index: number;
}

const ProductErrorItem = ({ productId, index }: ProductErrorItemProps) => {
    const { product } = useProduct(productId);

    if (!product) {
        return null;
    }

    return (
        <div className={`px-3 py-2 text-sm font-medium ${index % 2 === 0 ? "bg-white" : "bg-gray-lighter"}`}>
            {product.name}
        </div>
    );
};
